import { AdpImportFileDefinitionResponse } from "@herbjoy/apex-api-models";
import angular, { IPromise, IQService, ILogService } from "angular";
import { Transition, StateService } from "angular-ui-router";
import { RouteDeclaration, configureStates } from "../../core/router/router-helper.provider";
import { AdpConfigService } from "../../core/services/data-services/adp-config.service";
import { UtilityService } from "../../core/services/utility.service";
import { ValidAdpImportFileDefinition } from "./adp-config-editor/adp-config-editor.component";

const routes: RouteDeclaration[] = [{
    state: "adpConfig",
    config: {
        url: "/admin/adp-config",
        abstract: true
    }
}, {
    state: "adpConfig.list",
    config: {
        url: "",
        component: "apexAdpConfigList",
        resolve: {
            adpImportFileDefinitions: (adpConfigService: AdpConfigService) => {
                'ngInject';
                return adpConfigService.retrieveAdpImportDefinitions();
            },
            onDelete: ($state: StateService, adpConfigService: AdpConfigService) => {
                'ngInject';
                return ["$event", ({ id }: { id: number }) => {
                    return adpConfigService.deleteAdpImportDefinition(id)
                        .then(() => $state.reload());
                }]
            }
        },
        data: {
            pageHeader: "ADP Import File Definitions",
            permissionKey: "navigation:adpConfig"
        }
    }
}, {
    state: "adpConfig.new",
    config: {
        url: "/new",
        component: "apexAdpConfigEditor",
        resolve: {
            adpImportFileDefinition: () => {
                'ngInject';
                const blankDefinition: AdpImportFileDefinitionResponse = {
                    name: "",
                    definitions: [{}]
                };
                return blankDefinition;
            },
            onSave: ($state: StateService, adpConfigService: AdpConfigService) => {
                'ngInject';
                return ["$event", ({ definition }: { definition: ValidAdpImportFileDefinition }) => {
                    return adpConfigService.createAdpImportDefinition({
                        Name: definition.name,
                        Definitions: definition.definitions
                    }).then(id => {
                        $state.go("adpConfig.edit", { id });
                    });
                }];
            }
        },
        data: {
            pageHeader: "New ADP Import File Definition",
            permissionKey: "navigation:adpConfig"
        }
    }
}, {
    state: "adpConfig.clone",
    config: {
        url: "/{id:int}/clone",
        component: "apexAdpConfigEditor",
        resolve: {
            adpImportFileDefinition: ($log: ILogService, $state: StateService,
                $transition$: Transition, adpConfigService: AdpConfigService) => {
                'ngInject';
                const { id } = $transition$.params() as { id: number };
                return adpConfigService.retrieveAdpImportDefinition(id)
                    .then(definition => ({
                        ...definition,
                        id: null,
                        name: definition.name + " (Copy)"
                    }));
            },
            onSave: ($state: StateService, adpConfigService: AdpConfigService) => {
                'ngInject';
                return ["$event", ({ definition }: { definition: ValidAdpImportFileDefinition }) => {
                    return adpConfigService.createAdpImportDefinition({
                        Name: definition.name,
                        Definitions: definition.definitions
                    }).then(id => {
                        $state.go("adpConfig.edit", { id });
                    });
                }];
            }
        },
        data: {
            pageHeader: "Clone Existing",
            title: "ADP Config - Clone",
            permissionKey: "navigation:adpConfig"
        }
    }
}, {
    state: "adpConfig.edit",
    config: {
        url: "/{id:int}/edit",
        component: "apexAdpConfigEditor",
        resolve: {
            adpImportFileDefinition: ($transition$: Transition, adpConfigService: AdpConfigService) => {
                'ngInject';
                const { id } = $transition$.params();
                return adpConfigService.retrieveAdpImportDefinition(id);
            },
            onSave: ($q: IQService, adpConfigService: AdpConfigService,
                adpImportFileDefinition: AdpImportFileDefinitionResponse, utilityService: UtilityService) => {
                'ngInject';
                return ["$event", ({ definition }: { definition: ValidAdpImportFileDefinition }) => {
                    const changes: IPromise<any>[] = [];
                    if (adpImportFileDefinition.name !== definition.name) {
                        changes.push(adpConfigService.renameAdpImportDefinition(adpImportFileDefinition.id,
                            definition.name));
                    }
                    if (adpImportFileDefinition.definitions !== definition.definitions) {
                        // Check reference equality for now, as a subtitute for examining the full difference list.
                        changes.push(adpConfigService.updateAdpImportDefinition(adpImportFileDefinition.id,
                            definition.definitions));
                    }
                    const saved = $q.all(changes);
                    return utilityService.showLoadingUntilResolved(
                        utilityService.alertOnError(saved, "Saving failed")
                    );
                }];
            }
        },
        data: {
            pageHeader: "Edit ADP Import File Definition",
            permissionKey: "navigation:adpConfig"
        }
    }
}];

export const AdpConfigRoutingModule = angular
    .module("apex.adpConfig.routing", [])
    .run(configureStates(routes))
    .name;
